module.exports = __webpack_public_path__ + "static/img/TOY.6fc112e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/TOY.jpg
// module id = Ukzi
// module chunks = 1